import Phaser from "phaser";
import { data, dbObject, finance } from "../data";
import { createButton } from "../modules/createButton";
export default class Slot extends Phaser.Scene {
  width;
  height;
  scaleX;
  /** @type {Phaser.GameObjects.Text} */
  coinsText;
  /** @type {Phaser.GameObjects.Text} */
  freePlayText;
  /** @type {Phaser.GameObjects.Image} */
  legendBox;
  /** @type {Phaser.GameObjects.Image} */
  xIcon;
  /** @type {Phaser.GameObjects.Image} */
  arrowIcon;
  toggleArrow;
  /** @type {Phaser.GameObjects.Group} */
  page1;
  /** @type {Phaser.GameObjects.Group} */
  page2;
  /** @type {Phaser.Physics.Arcade.Group} */
  group1;
  g1Velocity;
  startG1Slow;
  group1Result;
  /** @type {Phaser.Physics.Arcade.Group} */
  group2;
  g2Velocity;
  startG2Slow;
  group2Result;
  /** @type {Phaser.Physics.Arcade.Group} */
  group3;
  g3Velocity;
  startG3Slow;
  group3Result;
  /** @type {Phaser.GameObjects.Image} */
  resultBar;
  /** @type {Phaser.GameObjects.Text} */
  resultText;
  childrenToAnimate;
  startAnimate;
  beginMoving;
  numberOfMoves;
  scaleUp;
  scaleDown;
  /** @type {Phaser.Geom.Circle} */
  circle;
  reduceRadius;
  constructor() {
    super("slot");
  }
  init() {
    this.width = this.sys.canvas.width;
    this.height = this.sys.canvas.height;
    this.scaleX = data().scaleX;
    this.coinsText = null;
    this.freePlayText = null;
    this.legendBox = null;
    this.xIcon = null;
    this.arrowIcon = null;
    this.page1 = null;
    this.page2 = null;
    this.toggleArrow = false;
    this.group1 = null;
    this.g1Velocity = 900;
    this.startG1Slow = false;
    this.group1Result = "";
    this.group2 = null;
    this.g2Velocity = 1500;
    this.startG2Slow = false;
    this.group2Result = "";
    this.group3 = null;
    this.g3Velocity = 1200;
    this.startG3Slow = false;
    this.group3Result = "";
    this.resultBar = null;
    this.resultText = null;
    this.childrenToAnimate = [];
    this.startAnimate = [false, false, false];
    this.beginMoving = [true, true, true];
    this.numberOfMoves = [0, 0, 0];
    this.scaleUp = true;
    this.scaleDown = false;
    this.circle = null;
    this.reduceRadius = false;
  }
  create() {
    this.createBg();
    this.createGameBoard();
    this.createGroups();
    this.addShadow();
    this.createFrame();
    this.addCoinAndPandaBars();
    this.addResultBar();
    this.addSpinButton();
    this.addLegendButton();
    this.createLegend();
    this.createCircle();
    dbObject.didOpenChest = true;
  }
  update(t, dt) {
    if (this.reduceRadius) {
      this.circle.radius -= 10;
      if (this.circle.radius <= 5) {
        this.circle.radius = 0;
        this.reduceRadius = false;
      }
    }
    this.group1.children.iterate((child) => {
      if (child.y > this.height / 2 + 220 * this.scaleX) {
        let y = child.y;
        this.group1.children.iterate((childAgain) => {
          if (childAgain.y <= y) {
            y = childAgain.y;
          }
        });
        child.y = y - 110 * this.scaleX;
      }
    });
    this.group2.children.iterate((child) => {
      if (child.y > this.height / 2 + 220 * this.scaleX) {
        let y = child.y;
        this.group2.children.iterate((childAgain) => {
          if (childAgain.y <= y) {
            y = childAgain.y
          }
        });
        child.y = y - 110 * this.scaleX;;
      }
    });
    this.group3.children.iterate((child) => {
      if (child.y > this.height / 2 + 220 * this.scaleX) {
        let y = child.y;
        this.group3.children.iterate((childAgain) => {
          if (childAgain.y <= y) {
            y = childAgain.y;
          }
        });
        child.y = y - 110 * this.scaleX;
      }
    });
    if (this.startG1Slow) {
      [this.g1Velocity, this.startG1Slow, this.group1Result] = this.slowDown(
        this.group1,
        this.g1Velocity,
        0
      );
    }
    if (this.startG2Slow) {
      [this.g2Velocity, this.startG2Slow, this.group2Result] = this.slowDown(
        this.group2,
        this.g2Velocity,
        1
      );
    }
    if (this.startG3Slow) {
      [this.g3Velocity, this.startG3Slow, this.group3Result] = this.slowDown(
        this.group3,
        this.g3Velocity,
        2
      );
    }
    if (this.group1Result && this.group2Result && this.group3Result) {
      this.getPrize(this.group1Result, this.group2Result, this.group3Result);
      this.group1Result = "";
      this.group2Result = "";
      this.group3Result = "";
    }
    this.startAnimate.forEach((item, i) => {
      if (item) {
        this.animateResult(this.childrenToAnimate[i], i);
      }
    });
  }
  createCircle() {
    this.circle = this.add.circle(
      this.width / 2,
      this.height / 2,
      this.width / 2 + 100 * this.scaleX,
      0xf2a900
    );
    this.time.delayedCall(2000, () => {
      this.reduceRadius = true;
    });
  }
  createBg() {
    this.add
      .image(this.width / 2, this.height / 2, "startBg")
      .setDisplaySize(this.width, this.height);
  }
  createGameBoard() {
    this.add
      .image(this.width / 2, this.height / 2 - 67 * this.scaleX, "gameBoard")
      .setScale(0.88 * this.scaleX);
  }
  createFrame() {
    this.add
      .image(this.width / 2, 50 * this.scaleX, "longBar")
      .setDisplaySize(this.width + 140 * this.scaleX, 0.7 * this.height);
    this.add
      .image(this.width / 2, this.height - 45 * this.scaleX, "longBar")
      .setDisplaySize(this.width + 300 * this.scaleX, 0.9 * this.height);
  }
  addCoinAndPandaBars() {
    /** @type {Phaser.GameObjects.Image} */
    this.add
      .image(-10 * this.scaleX, this.height + 3 * this.scaleX, "coinBar")
      .setOrigin(0, 1)
      .setScale(0.3 * this.scaleX, 0.37 * this.scaleX);
    this.add
      .image(230 * this.scaleX, this.height + 3 * this.scaleX, "pandaBar")
      .setOrigin(0, 1)
      .setScale(0.3 * this.scaleX, 0.37 * this.scaleX);
    this.coinsText = this.add
      .text(130 * this.scaleX, this.height - 70 * this.scaleX, finance.coins, {
        fontFamily: "Grooving",
        fontSize: "30px",
      })
      .setScale(this.scaleX);
    this.freePlayText = this.add
      .text(
        370 * this.scaleX,
        this.height - 70 * this.scaleX,
        finance.freePlay,
        {
          fontFamily: "Grooving",
          fontSize: "30px",
        }
      )
      .setScale(this.scaleX);
  }
  addResultBar() {
    this.resultBar = this.add
      .image(this.width / 2 + 150 * this.scaleX, 50 * this.scaleX, "longBar")
      .setDisplaySize(700 * this.scaleX, 250 * this.scaleX)
      .setVisible(false);
    this.resultText = this.add
      .text(this.width / 2 + 150 * this.scaleX, 50 * this.scaleX, "", {
        fontFamily: "Grooving",
        fontSize: "26px",
      })
      .setOrigin(0.5)
      .setScale(this.scaleX);
  }
  addSpinButton() {
    /** @type {Phaser.GameObjects.Image} */
    const spin = createButton(
      this,
      this.width - 10 * this.scaleX,
      this.height,
      "thickBar",
      0.3 * this.scaleX,
      () => {
        spin.disableInteractive();
        this.group1.setVelocityY(this.g1Velocity);
        this.group2.setVelocityY(this.g2Velocity);
        this.group3.setVelocityY(this.g3Velocity);
        this.time.delayedCall(Phaser.Math.Between(3000, 4000), () => {
          this.startG1Slow = true;
        });
        this.time.delayedCall(Phaser.Math.Between(6000, 7000), () => {
          this.startG2Slow = true;
        });
        this.time.delayedCall(Phaser.Math.Between(9000, 10000), () => {
          this.startG3Slow = true;
        });
      }
    );
    spin.setOrigin(1);
    this.add
      .text(
        this.width - 145 * this.scaleX,
        this.height - 85 * this.scaleX,
        "Spin",
        {
          fontFamily: "Grooving",
          fontSize: "40px",
        }
      )
      .setScale(this.scaleX);
  }
  addLegendButton() {
    /** @type {Phaser.GameObjects.Image} */
    const legend = createButton(
      this,
      50 * this.scaleX,
      -20 * this.scaleX,
      "thickBar",
      0.35 * this.scaleX,
      () => {
        this.toggleLegendBox(true);
      }
    );
    legend.setOrigin(0);
    this.add
      .text(85 * this.scaleX, 20 * this.scaleX, "Legend", {
        fontFamily: "Grooving",
        fontSize: "40px",
      })
      .setScale(this.scaleX);
  }
  createLegend() {
    this.legendBox = this.add
      .image(this.width / 2, this.height / 2 + 50 * this.scaleX, "blackRect")
      .setDisplaySize(this.width * 0.8, 1.7 * this.height)
      .setAlpha(0.9)
      .setVisible(false);
    this.xIcon = createButton(
      this,
      this.width - 200 * this.scaleX,
      60 * this.scaleX,
      "xIcon",
      0.1 * this.scaleX,
      () => {
        this.toggleLegendBox(false);
      }
    );
    this.arrowIcon = createButton(
      this,
      190 * this.scaleX,
      480 * this.scaleX,
      "arrowIcon",
      0.15 * this.scaleX,
      () => {
        this.toggleLegendPage(this.toggleArrow);
      }
    );
    this.xIcon.setVisible(false);
    this.arrowIcon.setVisible(false);
    const x = 75;
    this.page1 = this.add.group([
      this.addFirstPageRow(
        200,
        120 + x * 0,
        "Key: Three Key Icons",
        "key",
        "key",
        "key"
      ),
      this.addFirstPageRow(
        200,
        120 + x * 1,
        "Costume: Any Pair of Outfit Icons",
        "outfitGlow2",
        "5Coin",
        "outfitGlow2"
      ),
      this.addFirstPageRow(
        200,
        120 + x * 2,
        "Free play: Any Pair of Panda Icons",
        "freePlayIcon",
        "freePlayIcon",
        "key"
      ),
      this.addFirstPageRow(
        200,
        120 + x * 3,
        "5 Coins: Any Single 5 Coin Icon",
        "5Coin",
        "freePlayIcon",
        "outfitGlow2"
      ),
      this.addFirstPageRow(
        200,
        120 + x * 4,
        "10 Coins: Any Single 10 Coin Icon",
        "10Coin",
        "key",
        "freePlayIcon"
      ),
    ]);
    this.page2 = this.add.group([
      this.addSecondPageRow(
        300,
        120 + x * 0,
        "key",
        "Key: Advances you by one Level!"
      ),
      this.addSecondPageRow(
        300,
        120 + x * 1,
        "outfitGlow2",
        "Costume: Let you play with new outfit!"
      ),
      this.addSecondPageRow(
        300,
        120 + x * 2,
        "freePlayIcon",
        `Free play: Gives you an extra Chance
        at beating the game!`
      ),
      this.addSecondPageRow(
        300,
        120 + x * 3,
        "5Coin",
        "5 Coins: Gives 5 coins per Icon"
      ),
      this.addSecondPageRow(
        300,
        120 + x * 4,
        "10Coin",
        "10 Coins: Gives 10 coins per Icon"
      ),
    ]);
  }
  toggleLegendBox(event) {
    this.legendBox.setVisible(event);
    this.xIcon.setVisible(event);
    this.arrowIcon.setVisible(event);
    this.toggleArrow = false; // to make the first click effective
    this.page1.children.iterate((child) => {
      child.setVisible(event);
    });
    this.page2.children.iterate((child) => {
      child.setVisible(false);
    });
    if (!event) {
      this.arrowIcon.setFlipX(false); // to return the flipping arrow to its original position.
    }
  }
  toggleLegendPage(event) {
    this.page1.children.iterate((child) => {
      child.setVisible(event);
    });
    this.page2.children.iterate((child) => {
      child.setVisible(!event);
    });
    this.arrowIcon.setFlipX(!event);
    this.toggleArrow = !event;
  }
  addFirstPageRow(x, y, text, icon1, icon2, icon3) {
    const line = this.add.group([
      this.add
        .text(x * this.scaleX, y * this.scaleX, text, {
          fontFamily: "Grooving",
          fontSize: "25px",
        })
        .setOrigin(0, 0.5)
        .setScale(this.scaleX),
      this.add
        .image((x + 400) * this.scaleX, y * this.scaleX, icon1)
        .setOrigin(0.5)
        .setDisplaySize(75 * this.scaleX, 75 * this.scaleX),
      this.add
        .image((x + 470) * this.scaleX, y * this.scaleX, icon2)
        .setOrigin(0.5)
        .setDisplaySize(75 * this.scaleX, 75 * this.scaleX),
      this.add
        .image((x + 540) * this.scaleX, y * this.scaleX, icon3)
        .setOrigin(0.5)
        .setDisplaySize(75 * this.scaleX, 75 * this.scaleX),
    ]);
    line.setVisible(false);
    return line;
  }
  addSecondPageRow(x, y, icon, text) {
    const line = this.add.group([
      this.add
        .image(x * this.scaleX, y * this.scaleX, icon)
        .setOrigin(0.5)
        .setDisplaySize(75 * this.scaleX, 75 * this.scaleX),
      this.add
        .text((x + 70) * this.scaleX, y * this.scaleX, text, {
          fontFamily: "Grooving",
          fontSize: "25px",
        })
        .setOrigin(0, 0.5)
        .setScale(this.scaleX),
    ]);
    line.setVisible(false);
    return line;
  }
  createGroups() {
    let x = 130 * this.scaleX;
    let y = 110 * this.scaleX;
    this.group1 = this.physics.add.group([
      this.physics.add
        .image(this.width / 2 - x, this.height / 2 + -2 * y, "outfit")
        .setDisplaySize(110 * this.scaleX, 110 * this.scaleX),
      this.physics.add
        .image(this.width / 2 - x, this.height / 2 + -1 * y, "key")
        .setDisplaySize(110 * this.scaleX, 110 * this.scaleX),
      this.physics.add
        .image(this.width / 2 - x, this.height / 2 + 0 * y, "freePlayIcon")
        .setDisplaySize(110 * this.scaleX, 110 * this.scaleX),
      this.physics.add
        .image(this.width / 2 - x, this.height / 2 + 1 * y, "5Coin")
        .setDisplaySize(110 * this.scaleX, 110 * this.scaleX),
      this.physics.add
        .image(this.width / 2 - x, this.height / 2 + 2 * y, "10Coin")
        .setDisplaySize(110 * this.scaleX, 110 * this.scaleX),
    ]);
    this.group2 = this.physics.add.group([
      this.physics.add
        .image(this.width / 2 + 0 * x, this.height / 2 + -2 * y, "outfit")
        .setDisplaySize(110 * this.scaleX, 110 * this.scaleX),
      this.physics.add
        .image(this.width / 2 + 0 * x, this.height / 2 + -1 * y, "key")
        .setDisplaySize(110 * this.scaleX, 110 * this.scaleX),
      this.physics.add
        .image(this.width / 2 + 0 * x, this.height / 2 + 0 * y, "freePlayIcon")
        .setDisplaySize(110 * this.scaleX, 110 * this.scaleX),
      this.physics.add
        .image(this.width / 2 + 0 * x, this.height / 2 + 1 * y, "5Coin")
        .setDisplaySize(110 * this.scaleX, 110 * this.scaleX),
      this.physics.add
        .image(this.width / 2 + 0 * x, this.height / 2 + 2 * y, "10Coin")
        .setDisplaySize(110 * this.scaleX, 110 * this.scaleX),
    ]);
    this.group3 = this.physics.add.group([
      this.physics.add
        .image(this.width / 2 + x, this.height / 2 + -2 * y, "outfit")
        .setDisplaySize(110 * this.scaleX, 110 * this.scaleX),
      this.physics.add
        .image(this.width / 2 + x, this.height / 2 + -1 * y, "key")
        .setDisplaySize(110 * this.scaleX, 110 * this.scaleX),
      this.physics.add
        .image(this.width / 2 + x, this.height / 2 + 0 * y, "freePlayIcon")
        .setDisplaySize(110 * this.scaleX, 110 * this.scaleX),
      this.physics.add
        .image(this.width / 2 + x, this.height / 2 + 1 * y, "5Coin")
        .setDisplaySize(110 * this.scaleX, 110 * this.scaleX),
      this.physics.add
        .image(this.width / 2 + x, this.height / 2 + 2 * y, "10Coin")
        .setDisplaySize(110 * this.scaleX, 110 * this.scaleX),
    ]);
  }
  addShadow() {
    this.add
      .image(
        this.width / 2 - 5,
        this.height / 2 - 160 * this.scaleX,
        "blackRectBlur"
      )
      .setScale(0.88 * this.scaleX)
      .setAlpha(0.6);
    this.add
      .image(
        this.width / 2 - 5,
        this.height / 2 + 210 * this.scaleX,
        "blackRectBlur"
      )
      .setScale(0.88 * this.scaleX)
      .setAlpha(0.6);
  }
  /**
   * @param {Phaser.Physics.Arcade.Group} group
   */
  slowDown(group, velocity, i) {
    let startGSlow = true;
    let result = "";
    if (velocity > 50) {
      velocity -= 10;
      group.setVelocityY(velocity);
    } else {
      group.setVelocityY(50 * this.scaleX);
      group.children.iterate((child) => {
        if (this.height / 2 - 5 < child.y && child.y < this.height / 2 + 5) {
          this.sound.play("slotClick");
          group.setVelocityY(0);
          startGSlow = false;
          result = child.texture.key;
          this.childrenToAnimate[i] = child;
          this.time.delayedCall(400, () => {
            // to make the click sound comes few milliseconds before animation.
            this.startAnimate[i] = true;
          });
        }
      });
    }
    return [velocity, startGSlow, result];
  }
  /**
   * @param {Phaser.Physics.Arcade.Sprite} child
   */
  animateResult(child, i) {
    if (this.numberOfMoves[i] <= 8) {
      if (child.displayWidth > 140 * this.scaleX) {
        this.scaleUp = false;
        this.scaleDown = true;
      }
      if (child.displayWidth < 110 * this.scaleX) {
        this.scaleUp = true;
        this.scaleDown = false;
      }
      if (this.scaleUp) {
        child.setDisplaySize(child.displayWidth + 1, child.displayWidth + 1);
      }
      if (this.scaleDown) {
        child.setDisplaySize(child.displayWidth - 1, child.displayWidth - 1);
      }
    } else {
      if (child.displayWidth > 105 && child.displayWidth < 115) {
        child.setDisplaySize(110, 110);
      }
    }
    if (this.beginMoving[i]) {
      child.setAngularVelocity(400);
      this.beginMoving[i] = false;
    }
    if (child.angle > 45) {
      child.setAngularVelocity(-400);
    }
    if (child.angle < -45) {
      child.setAngularVelocity(400);
    }
    if (child.angle > -2 && child.angle < 2) {
      this.numberOfMoves[i]++;
    }
    if (this.numberOfMoves[i] > 10) {
      child.setAngularVelocity(0);
      child.angle = 0;
    }
  }
  getPrize(item1, item2, item3) {
    const items = [item1, item2, item3];
    let resultTextLocal = "";
    let key = 0;
    let outfit = 0;
    let freePlay = 0;
    let fiveCoins = 0;
    let tenCoins = 0;
    items.forEach((item) => {
      switch (item) {
        case "key":
          key++;
          break;
        case "outfit":
          outfit++;
          break;
        case "freePlayIcon":
          freePlay++;
          break;
        case "5Coin":
          fiveCoins++;
          break;
        case "10Coin":
          tenCoins++;
          break;
        default:
          console.log("nothing changed");
      }
    });
    this.time.delayedCall(2000, () => {
      if (key === 3) {
        finance.level++;
        resultTextLocal = "You win 1 key for matching 3 keys";
        dbObject.chestPrize[0] = "key";
      } else if (outfit >= 2) {
        finance.skinned = true;
        resultTextLocal = `You win 1 custom for matching ${outfit} outfits icon(s)`;
        dbObject.chestPrize[0] = "skin";
        if (tenCoins) {
          finance.coins = finance.coins + 10;
          dbObject.chestPrize.push("10 coins");
        } else if (fiveCoins) {
          finance.coins = finance.coins + 5;
          dbObject.chestPrize.push("5 coins");
        }
        this.coinsText.setText(finance.coins);
      } else if (freePlay >= 2) {
        finance.freePlay++;
        this.freePlayText.setText(finance.freePlay);
        resultTextLocal = `You win 1 free play for matching ${freePlay} free play icon(s)`;
        dbObject.chestPrize[0] = "freePlay";
        if (tenCoins) {
          finance.coins = finance.coins + 10;
          dbObject.chestPrize.push("10 coins");
        } else if (fiveCoins) {
          finance.coins = finance.coins + 5;
          dbObject.chestPrize.push("5 coins");
        }
        this.coinsText.setText(finance.coins);
      } else if (tenCoins) {
        if (fiveCoins) {
          resultTextLocal = `You win ${
            10 * tenCoins + 5 * fiveCoins
          } coins for matching ${tenCoins} ten coins and ${fiveCoins} five Coins`;
        } else {
          resultTextLocal = `You win ${
            10 * tenCoins
          } coins for matching ${tenCoins} ten coins`;
        }
        finance.coins = finance.coins + 10 * tenCoins + 5 * fiveCoins;
        this.coinsText.setText(finance.coins);
        dbObject.chestPrize[0] = `${10 * tenCoins + 5 * fiveCoins} coins`;
      } else if (fiveCoins) {
        resultTextLocal = `You win ${
          5 * fiveCoins
        } coins for matching ${fiveCoins} five coins`;
        finance.coins = finance.coins + 5 * fiveCoins;
        this.coinsText.setText(finance.coins);
        dbObject.chestPrize[0] = `${5 * fiveCoins} coins`;
      } else {
        resultTextLocal = "You Lost";
        dbObject.chestPrize[0] = "Did Not Win Anything";
      }
      this.resultBar.setVisible(true);
      this.resultText.setText(resultTextLocal);
      const finalText = (text, yFromHorizon) => {
        this.add
          .text(
            this.width / 2,
            this.height / 2 + yFromHorizon * this.scaleX,
            text,
            {
              fontSize: "40px",
              fontFamily: "Grooving",
              color: "black",
            }
          )
          .setOrigin(0.5)
          .setScale(this.scaleX);
      };
      this.time.delayedCall(2000, () => {
        this.add
          .image(this.width / 2, this.height / 2, "bambooFrame")
          .setDisplaySize(0.8 * this.width, 0.65 * this.height);
        if (resultTextLocal === "You Lost") {
          finalText("Aww Darn! Better Luck", -50);
          finalText("Next Time!", 50);
        } else if (finance.level === 4) {
          finance.level = 3;
          finalText("Key cannot be used at", -50);
          finalText("this point in the game! ", 50);
        } else {
          finalText("That Was A Great Spin!", -50);
          finalText("You Won!", 50);
        }
        this.time.delayedCall(2000, () => {
          switch (finance.level) {
            case 1:
              this.scene.start("easy");
              break;
            case 2:
              this.scene.start("medium");
              break;
            case 3:
              this.scene.start("hard");
              break;
            default:
              console.log("no level is matched");
          }
        });
      });
    });
  }
}
